import React from 'react';
import {
  Card,
  Text,
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';
import { Building20Regular, CheckmarkCircle20Regular } from '@fluentui/react-icons';
import { ApprovedDomain } from './types';

const useStyles = makeStyles({
  card: {
    ...shorthands.padding('16px'),
    ...shorthands.margin('0', '0', '16px', '0'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('8px'),
    marginBottom: '8px',
  },
  domainName: {
    fontSize: '16px',
    fontWeight: '600',
    fontFamily: 'monospace',
    color: tokens.colorNeutralForeground1,
  },
  organization: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('6px'),
    color: tokens.colorNeutralForeground3,
    fontSize: '13px',
  },
});

interface DomainCardProps {
  domain: ApprovedDomain;
  compact?: boolean;
}

export const DomainCard: React.FC<DomainCardProps> = ({ domain, compact = false }) => {
  const styles = useStyles();
  const domainTestId = domain.domain.toLowerCase().replace(/[^a-z0-9]+/g, '-');

  return (
    <Card className={styles.card} data-testid={`domain-card-${domainTestId}`}>
      <div className={styles.header} data-testid={`domain-card-header-${domainTestId}`}>
        <Text className={styles.domainName} data-testid={`domain-card-name-${domainTestId}`}>{domain.domain}</Text>
      </div>
      
      {domain.organization && (
        <div className={styles.organization} data-testid={`domain-card-organization-${domainTestId}`}>
          <Building20Regular data-testid={`domain-card-organization-icon-${domainTestId}`} />
          <Text data-testid={`domain-card-organization-name-${domainTestId}`}>{domain.organization}</Text>
        </div>
      )}
    </Card>
  );
};
